import cn from 'classnames';
import * as React from 'react';

import s from './Container.module.scss';

type Props = React.PropsWithChildren<
  React.HTMLAttributes<HTMLDivElement> & {
    className?: string;
  }
>;

export const Container = React.forwardRef<HTMLDivElement, Props>(({ children, className, ...rest }, ref) => {
  return (
    <div ref={ref} className={cn(s.root, className)} {...rest}>
      {children}
    </div>
  );
});

Container.displayName = 'Container';

export default Container;
